import { CanMatchFn, Router, UrlSegment } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../oglasnik-v3/shared/services/auth.service';
import { UserRole } from '../../oglasnik-v3/shared/models/user-profile.model';
import { roleHomePath } from '../utils/role-home.util';
import { sigurnaPovratnaPutanja } from '../utils/povratak.util';

/**
 * Kombinirani auth + role guard. Factory: prima listu dopuštenih rola (OR).
 * Provjeri login PA rolu (redoslijed bitan — default role() se ne čita za anonimnog).
 * Anonimni → /login?returnUrl=<tražena putanja> (npr. CTA „Pogledaj upite” → /dashboard/burza);
 * nedopuštena rola → vlastiti home (roleHomePath).
 */
export const roleGuard = (...allowed: UserRole[]): CanMatchFn => (_route, segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) {
    const trazeno = router.getCurrentNavigation()?.extractedUrl.toString()
      ?? '/' + segments.map(s => s.path).join('/');
    const returnUrl = sigurnaPovratnaPutanja(trazeno);
    return router.createUrlTree(['/login'], returnUrl ? { queryParams: { returnUrl } } : {});
  }
  return allowed.includes(auth.role())
    ? true
    : router.createUrlTree(roleHomePath(auth.role()));
};
